var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

define(['jquery', 'underscore', 'backbone', 'core', 'app-common/component/popover', 'app-common/view/clients-events', 'common/component/date-formatter', 'app-common/template/clients-events-grouped.htm', 'app-common/template/clients-events-plain.htm'], function($, _, Backbone, core, Popover, ClientsEventsView, dateFormatter, groupedEventsTemplate, plainEventsTemplate) {
  var ClientsEventsPopover;
  return ClientsEventsPopover = (function(_super) {

    __extends(ClientsEventsPopover, _super);

    function ClientsEventsPopover() {
      ClientsEventsPopover.__super__.constructor.apply(this, arguments);
    }

    ClientsEventsPopover.prototype.events = _.extend({}, ClientsEventsView.prototype.events, {
      'click .clients-event-group-name': 'showEvents',
      'click .clients-event-table a': 'trackEventNavigation',
      'click .clients-event-table .remove-clients-event': 'trackEventRemoval'
    });

    ClientsEventsPopover.prototype.initialize = function() {
      this.on('event:removed', this.removeAction, this);
      return this.on('event.group:removed', this.removeGroupAction, this);
    };

    ClientsEventsPopover.prototype.decreaseTotalCounter = function(decreaseNumber) {
      var eventsTotal;
      eventsTotal = parseInt(this.$el.find('.total-events').text());
      if (eventsTotal - decreaseNumber === 0) {
        this.$el.find('.total-events').text(0);
        return this.$el.hide();
      } else {
        return this.$el.find('.total-events').text(eventsTotal - decreaseNumber);
      }
    };

    ClientsEventsPopover.prototype.removeAction = function(element, data) {
      if (element.closest('.clients-event-group-table').find('tr').length === 1) {
        $(".clients-event-group[data-group-name='" + data.name + "']").remove();
      } else {
        this.decreaseGroupCounter(data.name, data.count);
      }
      element.remove();
      return this.decreaseTotalCounter(data.count);
    };

    ClientsEventsPopover.prototype.removeGroupAction = function(element, data) {
      $(".clients-event-group[data-group-name='" + data.name + "']").remove();
      $(".clients-event-group-table-wrapper[data-group-name='" + data.name + "']").remove();
      return this.decreaseTotalCounter(data.count);
    };

    ClientsEventsPopover.prototype.showEvents = function(e) {
      var element, groupName;
      element = $(e.currentTarget).closest('.clients-event-group');
      groupName = element.data('group-name');
      return this.$el.find(".clients-event-group-table-wrapper[data-group-name='" + groupName + "']").slideToggle('fast');
    };

    ClientsEventsPopover.prototype.trackEventRemoval = function(e) {
      return this.trackRemoval(e, false);
    };

    ClientsEventsPopover.prototype.trackEventNavigation = function(e) {
      return this.trackNavigation(e, false);
    };

    ClientsEventsPopover.prototype.findClientDataById = function(clientId) {
      return {
        id: core.getCurrentClientId(),
        company: core.getCurrentClient().get('company'),
        fullName: core.getCurrentClient().get('fullName')
      };
    };

    /*
    # @param Int userId can be bookkeeperId or clientId
    # @param Array[String] List of client roles
    */


    ClientsEventsPopover.prototype.show = function(userId, clientRoles) {
      var mode,
        _this = this;
      if (__indexOf.call(clientRoles, 'USER') >= 0) {
        mode = 'bk';
      } else if (__indexOf.call(clientRoles, 'SALES') >= 0) {
        mode = 'sales';
      } else if (__indexOf.call(clientRoles, 'TAX_ACCOUNTANT') >= 0) {
        mode = 'ta';
      } else {
        mode = 'client';
      }
      return this.getEventsStats(userId, null, mode, function(response) {
        var stats;
        stats = response[0].events.stats;
        if (!stats || stats.total < 1) {
          return;
        }
        _this.$el.on('click', function(e) {
          var button, popover;
          button = $(e.currentTarget);
          popover = new Popover(button, 'bottom');
          return popover.action(e, function() {
            return _this.getEvents(userId, null, mode, function(response) {
              var groupingEnabled, preprocessedEvents;
              groupingEnabled = mode === 'bk' || mode === 'sales';
              preprocessedEvents = _this.preprocessEvents(response[0].events.full, groupingEnabled);
              if (groupingEnabled) {
                popover.build(_.template(groupedEventsTemplate, {
                  eventGroups: preprocessedEvents,
                  core: core,
                  dateFormatter: dateFormatter,
                  formatGroupName: _this.formatGroupName
                }));
              } else {
                popover.build(_.template(plainEventsTemplate, {
                  events: preprocessedEvents,
                  core: core,
                  dateFormatter: dateFormatter
                }));
              }
              return popover.show();
            });
          });
        });
        _this.$el.find('.total-events').text(stats.total);
        return _this.$el.show();
      });
    };

    return ClientsEventsPopover;

  })(ClientsEventsView);
});
